<template>
    <div style="width: 100%">
        <!-- <v-row class="pa-1">
			 <v-col cols="12"> -->
        <v-divider />
        <div>
            <v-tabs touchless v-model="tab" fixed-tabs>
                <v-tab
                    active-class="primary--text"
                    class="text--darken-2 grey--text"
                    ref="tab"
                    :to="{
                        name: 'calculadora',
                    }"
                >
                    Calculadora
                </v-tab>
                <v-tab
                    v-if="hasAdminPermission"
                    active-class="primary--text"
                    class="text--darken-2 grey--text"
                    ref="tab"
                    :to="{
                        name: 'liquidacion',
                    }"
                >
                    Liquidacion
                </v-tab>
                <v-tab
                    active-class="primary--text"
                    class="text--darken-2 grey--text"
                    :to="{
                        name: 'calendario',
                    }"
                >
                    Calendario
                </v-tab>

                <v-tab
                    active-class="primary--text"
                    class="text--darken-2 grey--text"
                    :to="{
                        name: 'miZona',
                    }"
                >
                    Mi zona
                </v-tab>

                <v-tab
                    v-if="hasAdminPermission"
                    active-class="primary--text"
                    class="text--darken-2 grey--text"
                    ref="tab"
                    :to="{
                        name: 'listaUpfronts',
                    }"
                >
                    Lista Upfronts
                </v-tab>
                <div ref="top"></div>
            </v-tabs>
        </div>
        <v-divider />

        <router-view></router-view>
        <!-- <div id="control-height"></div> -->
    </div>
</template>

<script lang="js">
import { mapGetters } from 'vuex';
//import Calendario from './Calendario/Calendario.vue';
// import Calculadora from './Calculadora/Calculadora.vue';
// import MiZona from './MiZona/MiZona.vue';
// import TablaUpfront from './Calculadora/TablaUpfront.vue';

export default {
	// components: {
	// 	Calendario,
	// 	Calculadora,
	// 	MiZona,
	// 	TablaUpfront,
	// },
	data: () => ({
		tab: null,
		theme: 'light',
		container_width: '100%',
		areapersonal_item_height: '100%',
		height: 100,
	}),
	computed: {
		...mapGetters('login', {
			hasAdminPermission: 'hasAdminPermission',
		}),
	},
	methods: {
		resize() {
			this.height =
				document.getElementById('control-height').clientHeight -
				48 -
				48 -
				18;
		},
	},
	mounted() {

	},
	beforeCreate(){
		// if (this.$store.state.areaPersonal.calendario.agendados.length == 0 && !this.$store.state.areaPersonal.calendario.requestedAgendados) {
		// 	this.$store.dispatch("areaPersonal/calendario/fetchAgendados")
		// 	this.$store.commit("areaPersonal/calendario/requestedAgendados", true)
		// }
	},
};
</script>

<style>
#control-height {
    height: 100vh;
    width: 100%;
    position: fixed;
}
.v-slide-group__prev {
    width: 0px !important;
    flex: 0 1 0px !important;
}
</style>